import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { Operation } from 'stores/type';

export const useOperation = (operation: Operation) => {
    const operations = useSelector<RootState, Operation[]>(state => state.userInfo.operation);
    return operations.includes(operation);
};
